"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var SvgRefreshCcw02 = function (props) { return ((0, jsx_runtime_1.jsx)("svg", __assign({ width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props, { children: (0, jsx_runtime_1.jsx)("path", { d: "M19.071 4.929c-3.905-3.905-10.237-3.905-14.142 0A50.851 50.851 0 0 0 3 6.954V4a1 1 0 0 0-2 0v6a1 1 0 0 0 1 1h6a1 1 0 1 0 0-2H3.874c.513-.617 1.291-1.479 2.47-2.657A8 8 0 0 1 19.8 10.221a1 1 0 0 0 1.95-.442 9.958 9.958 0 0 0-2.68-4.85ZM4.2 13.779a1 1 0 0 0-1.951.442 9.957 9.957 0 0 0 2.68 4.85c3.905 3.905 10.237 3.905 14.142 0A50.767 50.767 0 0 0 21 17.046V20a1 1 0 1 0 2 0v-6a1 1 0 0 0-1-1h-6a1 1 0 1 0 0 2h4.126c-.512.616-1.29 1.478-2.47 2.657A8 8 0 0 1 4.2 13.779Z", fill: "currentColor" }) }))); };
exports.default = SvgRefreshCcw02;
